import { TSection } from '../../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsReadAllFromSectionDesktopRequestSchema';
import {
  TChatsBulkOperationsReadAllFromSectionDesktopResponse,
  fetchChatsBulkOperationsReadAllFromSectionDesktop,
} from '../../repositories/chats/v1/chats/bulk-operations/read-all-from-section-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { toggleChatListPending } from '../chatList/actions';

/**
 * Пометить все чаты как прочитанные
 * @param {ESection} section раздел в котором нужно прочитать сообщения
 */
export const markAllChatsAsRead =
  (section: TSection): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsReadAllFromSectionDesktopResponse =
        await fetchChatsBulkOperationsReadAllFromSectionDesktop({
          httpApi,
          parameters: {
            section,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode !== 200) {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось пометить все чаты прочитанными',
          domain: 'src/shared/actions/chatList/markAllChatsAsRead.ts',
          statusCode,
          messsage: response.message || 'Неизвестная ошибка',
          errors: JSON.stringify(response?.errors),
        });

        dispatch(showAlert({ message: 'Не удалось пометить все чаты прочитанными' }));
      }
    } catch (ex) {
      logger.error(ex, {
        message: 'Не удалось пометить все чаты прочитанными',
        domain: 'src/shared/actions/chatList/markAllChatsAsRead.ts',
      });

      dispatch(showAlert({ message: 'Не удалось пометить все чаты прочитанными' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
